import axios from 'axios'
import React, { useEffect, useState } from 'react'

const MerchantRegistration = () => {
  
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [merchantName, setMerchantName] = useState('');
  const [userName, setUserName] = useState('');

  const [address, setAddress] = useState('');
  const [referralCode, setReferralCode] = useState('');



  const [brandName, setBrandName] = useState('');
  const [industry, setIndustry] = useState('');
  const [category, setCategory] = useState('');
  const [mobile, setMobile] = useState('');
  const [adminId, setAdminId] = useState(0);
  const [merchatSiteUrl, setMerchatSiteUrl] = useState('');
  const [passwordResetToken, setPasswordResetToken] = useState('');
  const [resetTokenExpiryDate, setResetTokenExpiryDate] = useState('');
  const [emailConfirmationToken, setEmailConfirmationToken] = useState('');
  const [isEmailConfirmed, setIsEmailConfirmed] = useState(true);
  const [referredByType, setReferredByType] = useState('Merchant');
  const [registeredOn, setRegisteredOn] = useState('');
  const [referredByCode, setReferredByCode] = useState('');

  const [error, setError] = useState('');

  const currentDate = new Date();



  useEffect(()=>{
    setResetTokenExpiryDate(currentDate)
    setRegisteredOn(currentDate)
  },[])


  useEffect(() => {
    const merchantData = JSON.parse(localStorage.getItem("merchantLogin"))
    setMerchantName(merchantData.name)
    setEmail(merchantData.email)
    setPassword(merchantData.email)
    setUserName(merchantData.name)
  }, [])

  // console.log("merchantName", merchantName)
  // console.log("email", email)
  // console.log("password", password)
  // console.log("userName", userName)

  const formHandiling = (e) => {
    e.preventDefault();
    if (!/^[0-9]{10}$/.test(mobile)) {
      setError("Please Check your Mobile Number");
      return;
    } 
    setError("")
    axios.post('https://api.bakpoket.com/api/MerchantDetails',{
      email,
      password,
      merchantName,
      userName,
      address,
      referralCode,
      brandName,
      industry,
      category,
      mobile,
      adminId,
      merchatSiteUrl,
      passwordResetToken,
      resetTokenExpiryDate,
      emailConfirmationToken,
      isEmailConfirmed,
      referredByType,
      registeredOn,
      referredByCode
    })
    .then((res)=>{
      alert("Merchant Details Submitted Successfully")
      // console.log("res", res.data)
      localStorage.setItem("merchantDashboardLogin", JSON.stringify(res.data))
      setCategory("")
      setMobile("")
      setMerchatSiteUrl("")
      window.location.reload()
    })
    .catch((err)=>{
      console.log("err", err)
      alert("Error in submitting merchant details")
    })

  }

  useEffect(() => {

  }, [mobile])

  return (
    <div className="container my-3 d-flex align-items-center justify-content-center flex-column" style={{ height: "60vh" }}>
      <div className="card" style={{ maxWidth: "400px" }}>
        <div className="card-body ">
          <h4 className="card-title text-center">Enter Merchant Details</h4>
          <form onSubmit={formHandiling}>
            <div className="mb-3">
              <label className='text-start ps-2 mb-1'>Email:</label>
              <input type="text" className="form-control" placeholder="Enter category" readOnly value={email} disabled />
            </div>
            <div className="mb-3">
              <label htmlFor="category" className='text-start ps-2 mb-1'>Category:</label>
              <input type="text" className="form-control" id="category" placeholder="Enter category" required />
            </div>
            <div className="mb-3">
              <label htmlFor="mobile" className='ps-2 mb-1'>Mobile Number:</label>
              <input type="text" className="form-control" id="mobile" placeholder="Enter mobile" onChange={(e) => setMobile(e.target.value)} required />
            </div>
            <div className="mb-3">
              <label htmlFor="merchantsite" className='ps-2 mb-1'>Merchant Site:</label>
              <input type="text" className="form-control" id="merchantsite" placeholder="Enter Merchant Site (optional)" onChange={(e) => setMerchatSiteUrl(e.target.value)} />
            </div>
            {error && <p className="text-danger mt-1 text-center" style={{ fontSize: "12px" }}>{error}</p>}
            <div className='w-100 d-flex justify-content-center'>
              <button type="submit" className="btn rounded-pill px-4 py-2" style={{ width: "70%" }}>Submit</button>
            </div>
          </form>
        </div>

      </div>
    </div>
  )
}

export default MerchantRegistration;